export const DraggableType = {
    None: 'none',
    Internal: 'internal',
    External: 'external',
    All: 'all',
};
